<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                  <div class="card-header align-items-center border-bottom-dark px-0">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        FAQ Management
                      </h3>
                    </div>
                    <div class="icons d-flex">
                      <button
                        class="btn ml-2 p-0 kt_notes_panel_toggle"
                        data-toggle="tooltip"
                        title="Add FAQ"
                        data-placement="right"
                      >
                        <span
                          class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                          v-on:click="display_form = !display_form"
                        >
                          <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filters Row -->
            <div class="row mb-3">
              <div class="col-md-4">
                <select
                  v-model="filterCategoryId"
                  class="form-control"
                  @change="fetchFaqs()"
                >
                  <option value="">All Categories</option>
                  <option
                    v-for="cat in faqCategories"
                    :key="cat.faq_category_id"
                    :value="cat.faq_category_id"
                  >
                    {{ cat.faq_category_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="table-responsive" id="printableTable">
                      <div id="faqTable_wrapper" class="dataTables_wrapper no-footer">
                        <div class="dataTables_length" id="faqTable_length">
                          <label>
                            Show
                            <select
                              name="faqTable_length"
                              class=""
                              v-model="limit"
                              v-on:change="fetchFaqs()"
                            >
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                            entries
                          </label>
                        </div>
                        <div id="faqTable_filter" class="dataTables_filter">
                          <label>
                            Search:
                            <input
                              type="search"
                              class=""
                              placeholder=""
                              v-model="searchParameter"
                              @keyup="fetchFaqs()"
                            />
                          </label>
                        </div>

                        <table id="faqTable" class="display dataTable no-footer" role="grid">
                          <thead class="text-body">
                            <tr role="row">
                              <th
                                class="sorting"
                                @click="sorting('id')"
                                :class="
                                  (sortType == 'asc' || sortType == 'ASC') && sortBy == 'id'
                                    ? 'sorting_asc'
                                    : (sortType == 'desc' || sortType == 'DESC') && sortBy == 'id'
                                    ? 'sorting_desc'
                                    : 'sorting'
                                "
                              >ID</th>
                              <th class="sorting_disabled">Category</th>
                              <th class="sorting_disabled">Question</th>
                              <th class="sorting_disabled">Status</th>
                              <th
                                class="sorting"
                                @click="sorting('sort_order')"
                                :class="
                                  (sortType == 'asc' || sortType == 'ASC') && sortBy == 'sort_order'
                                    ? 'sorting_asc'
                                    : (sortType == 'desc' || sortType == 'DESC') && sortBy == 'sort_order'
                                    ? 'sorting_desc'
                                    : 'sorting'
                                "
                              >Sort</th>
                              <th class="no-sort sorting_disabled">Action</th>
                            </tr>
                          </thead>
                          <tbody class="kt-table-tbody text-dark">
                            <tr
                              class="kt-table-row kt-table-row-level-0 odd"
                              role="row"
                              v-for="faqItem in faqs"
                              :key="faqItem.faq_id"
                            >
                              <td class="sorting_1">{{ faqItem.faq_id }}</td>
                              <td>{{ getCategoryName(faqItem.faq_category_id) }}</td>
                              <td style="max-width:300px;">
                                <span :title="faqItem.faq_question">
                                  {{ faqItem.faq_question.length > 80 ? faqItem.faq_question.substring(0, 80) + '...' : faqItem.faq_question }}
                                </span>
                              </td>
                              <td>
                                <span :class="faqItem.faq_status === 'active' ? 'badge badge-success' : 'badge badge-danger'">
                                  {{ faqItem.faq_status }}
                                </span>
                              </td>
                              <td>{{ faqItem.faq_sort_order }}</td>
                              <td>
                                <a
                                  href="javascript:void(0)"
                                  class="click-edit"
                                  data-toggle="tooltip"
                                  title="Edit"
                                  @click="editFaq(faqItem)"
                                >
                                  <i class="fa fa-edit"></i>
                                </a>
                                <a
                                  href="javascript:void(0)"
                                  class="ml-2"
                                  data-toggle="tooltip"
                                  title="Delete"
                                  @click="deleteFaq(faqItem.faq_id)"
                                >
                                  <i class="fa fa-trash text-danger"></i>
                                </a>
                              </td>
                            </tr>
                            <tr v-if="faqs.length === 0">
                              <td colspan="6" class="text-center">No FAQs found.</td>
                            </tr>
                          </tbody>
                        </table>

                        <ul class="pagination pagination-sm m-0 float-right">
                          <li :class="[{ disabled: !pagination.prev_page_url }]">
                            <button class="page-link" @click="fetchFaqs(pagination.prev_page_url)">Previous</button>
                          </li>
                          <li class="disabled">
                            <a class="page-link text-dark" href="#">
                              Page {{ pagination.current_page }} of {{ pagination.last_page }}
                            </a>
                          </li>
                          <li :class="[{ disabled: !pagination.next_page_url }]" class="page-item">
                            <button class="page-link" @click="fetchFaqs(pagination.next_page_url)">Next</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Offcanvas Slide-in Form -->
    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
        <h4 class="font-size-h4 font-weight-bold m-0">
          {{ edit ? 'Edit FAQ' : 'Add FAQ' }}
        </h4>
        <a
          href="#"
          class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close"
          v-on:click="clearForm()"
        >
          <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
          </svg>
        </a>
      </div>

      <form id="faqForm">
        <div class="row">
          <div class="col-12">

            <div class="form-group">
              <label class="text-dark">Category <span class="text-danger">*</span></label>
              <select v-model="faq.faq_category_id" class="form-control">
                <option value="">-- Select Category --</option>
                <option
                  v-for="cat in faqCategories"
                  :key="cat.faq_category_id"
                  :value="cat.faq_category_id"
                >
                  {{ cat.faq_category_name }}
                </option>
              </select>
              <small class="text-danger" v-if="errors.faq_category_id">{{ errors.faq_category_id[0] }}</small>
            </div>

            <div class="form-group">
              <label class="text-dark">Question <span class="text-danger">*</span></label>
              <textarea
                v-model="faq.question"
                class="form-control"
                rows="3"
                placeholder="Enter the question"
              ></textarea>
              <small class="text-danger" v-if="errors.question">{{ errors.question[0] }}</small>
            </div>

            <div class="form-group">
              <label class="text-dark">Answer <span class="text-danger">*</span></label>
              <textarea
                v-model="faq.answer"
                class="form-control"
                rows="6"
                placeholder="Enter the answer"
              ></textarea>
              <small class="text-danger" v-if="errors.answer">{{ errors.answer[0] }}</small>
            </div>

            <div class="form-group">
              <label class="text-dark">Status</label>
              <select v-model="faq.status" class="form-control">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            <div class="form-group">
              <label class="text-dark">Sort Order</label>
              <input
                type="number"
                v-model="faq.sort_order"
                class="form-control"
                placeholder="0"
              />
            </div>

          </div>
        </div>

        <button
          type="button"
          class="btn btn-primary"
          @click="submittedForm()"
        >
          {{ edit ? 'Update' : 'Save' }}
        </button>
        <button
          type="button"
          class="btn btn-secondary ml-2"
          @click="clearForm()"
        >
          Cancel
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  data() {
    return {
      display_form: false,
      edit: false,
      faqs: [],
      faqCategories: [],
      pagination: {},
      limit: 10,
      searchParameter: '',
      sortBy: 'sort_order',
      sortType: 'ASC',
      filterCategoryId: '',
      errors: {},
      token: [],
      faq: {
        faq_category_id: '',
        question: '',
        answer: '',
        status: 'active',
        sort_order: 0,
      },
    };
  },
  mounted() {
    var token = localStorage.getItem('token');
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchFaqCategories();
    this.fetchFaqs();
  },
  methods: {
    fetchFaqCategories() {
      axios.get(`/api/admin/faq_category?limit=1000&onlyActive=1`, this.token).then((res) => {
        if (res.data.status === 'Success') {
          this.faqCategories = res.data.data || [];
        }
      });
    },
    getCategoryName(id) {
      const cat = this.faqCategories.find((c) => c.faq_category_id === id);
      return cat ? cat.faq_category_name : '-';
    },
    fetchFaqs(page_url = null) {
      let url = `/api/admin/faq?limit=${this.limit}&sortBy=${this.sortBy}&sortType=${this.sortType}`;
      if (this.searchParameter) {
        url += `&searchParameter=${this.searchParameter}`;
      }
      if (this.filterCategoryId) {
        url += `&faq_category_id=${this.filterCategoryId}`;
      }
      if (page_url) {
        url = page_url + `&limit=${this.limit}&sortBy=${this.sortBy}&sortType=${this.sortType}`;
        if (this.searchParameter) url += `&searchParameter=${this.searchParameter}`;
        if (this.filterCategoryId) url += `&faq_category_id=${this.filterCategoryId}`;
      }
      axios.get(url, this.token).then((res) => {
        if (res.data.status === 'Success') {
          this.faqs = res.data.data || [];
          this.pagination = {
            current_page: res.data.meta.current_page,
            last_page: res.data.meta.last_page,
            prev_page_url: res.data.links.prev,
            next_page_url: res.data.links.next,
          };
        }
      });
    },
    editFaq(faqItem) {
      this.edit = true;
      this.display_form = true;
      this.faq = {
        id: faqItem.faq_id,
        faq_category_id: faqItem.faq_category_id,
        question: faqItem.faq_question,
        answer: faqItem.faq_answer,
        status: faqItem.faq_status,
        sort_order: faqItem.faq_sort_order,
      };
    },
    deleteFaq(id) {
      this.$confirm('Are you sure you want to delete this FAQ?').then(() => {
        axios.delete(`/api/admin/faq/${id}`, this.token).then((res) => {
          if (res.data.status === 'Success') {
            this.$toaster.success(res.data.message);
            this.fetchFaqs();
          } else {
            this.$toaster.error(res.data.message);
          }
        });
      });
    },
    submittedForm() {
      this.errors = {};
      if (this.edit) {
        axios
          .put(`/api/admin/faq/${this.faq.id}`, this.faq, this.token)
          .then((res) => {
            if (res.data.status === 'Success') {
              this.$toaster.success(res.data.message);
              this.clearForm();
              this.fetchFaqs();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.errors = error.response.data.errors;
            }
          });
      } else {
        axios
          .post(`/api/admin/faq`, this.faq, this.token)
          .then((res) => {
            if (res.data.status === 'Success') {
              this.$toaster.success(res.data.message);
              this.clearForm();
              this.fetchFaqs();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.errors = error.response.data.errors;
            }
          });
      }
    },
    clearForm() {
      this.display_form = false;
      this.edit = false;
      this.errors = {};
      this.faq = {
        faq_category_id: '',
        question: '',
        answer: '',
        status: 'active',
        sort_order: 0,
      };
    },
    sorting(col) {
      if (this.sortBy === col) {
        this.sortType = this.sortType === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortBy = col;
        this.sortType = 'ASC';
      }
      this.fetchFaqs();
    },
  },
};
</script>
